module.exports = __webpack_public_path__ + "img/000082.f53b2cee.png";